import type { ReactNode } from 'react';
import { X } from 'lucide-react';

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  width?: 'sm' | 'md' | 'lg';
}

const WIDTHS: Record<NonNullable<Props['width']>, string> = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-2xl',
};

export function Modal({
  open,
  title,
  onClose,
  children,
  footer,
  width = 'md',
}: Props): JSX.Element | null {
  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal
      className="fixed inset-0 z-50 flex items-center justify-center bg-bg/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className={`panel-shell w-full ${WIDTHS[width]} mx-4`}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="flex items-center justify-between px-5 py-3 border-b border-border">
          <h2 className="text-sm font-semibold text-text">{title}</h2>
          <button
            onClick={onClose}
            className="text-text-mute hover:text-text transition"
            aria-label="Schließen"
          >
            <X size={16} />
          </button>
        </header>
        <div className="p-5">{children}</div>
        {footer ? (
          <footer className="px-5 py-3 border-t border-border flex justify-end gap-2">
            {footer}
          </footer>
        ) : null}
      </div>
    </div>
  );
}
